module.exports = __webpack_public_path__ + "static/media/ZA.8dc48856.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/ZA.svg
// module id = 2295
// module chunks = 7